import { RECEIPT_STEPS } from "../receipt-steps.service";
import { BaseState } from "./base-state";
import { ExpenseSelectionState } from "./expense-selection-state";
import { StepStateInterface } from "./step-state.interface";

export class OtherDataState extends BaseState implements StepStateInterface {
  ClassConstructor = OtherDataState;
  property = 'otherData';
  slug = RECEIPT_STEPS.otherData;
  lastStep = true;
  async previous(context: any): Promise<StepStateInterface> {
    return new ExpenseSelectionState();
  }
}
